<template>
  <div class="vipRules">
    <img class="heade-bg" src="/images/relationChain/rules_header.png" alt="">
    <div class="reset-bg">
      <img src="/images/relationChain/rules_01.png" alt="">
      <img src="/images/relationChain/rules_02.png" alt="">
    </div>
    <img class="lines" src="/images/relationChain/rules_lines.png" alt="">
    <img src="/images/relationChain/rules_03.png" alt="">
    <img class="lines" src="/images/relationChain/rules_lines.png" alt="">
    <div class="reset-bg">
      <img src="/images/relationChain/rules_04.png" alt="">
      <img src="/images/relationChain/rules_05.png" alt="">
    </div>
    <img class="lines" src="/images/relationChain/rules_lines.png" alt="">
    <img src="/images/relationChain/rules_06.png" alt="">
    <img class="lines" src="/images/relationChain/rules_lines.png" alt="">
    <img src="/images/relationChain/rules_07.png" alt="">
    <img class="lines" src="/images/relationChain/rules_lines.png" alt="">
    <img src="/images/relationChain/rules_08.png" alt="">
    <img class="lines" src="/images/relationChain/rules_lines.png" alt="">
    <img src="/images/relationChain/rules_09.png" alt="">
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  mounted () {}
}
</script>
<style scoped>
.vipRules{
  width: 100vw;
  background: #74b3fa;
  padding-bottom: 58px;
  font-size: 0;
}
.reset-bg{
  background: #fff;
  width: 351px;
  margin: 0 auto;
  border-radius: 18px;
}
.vipRules img{
  display: block;
  width: 351px;
  margin: 0 auto;
}
.vipRules .heade-bg{
  width: 100%;
}
.vipRules .lines{
  width: 252px;
}
</style>

